export const TERMS_LAST_UPDATED = '23 de marzo de 2026';

export const TERMS_SECTIONS = [
    {
        title: '1. Aceptacion de terminos',
        paragraphs: [
            'Al navegar, registrarte o utilizar MyHoommy, aceptas estos Terminos y Condiciones, la Politica de Privacidad y las demas politicas aplicables de la plataforma.',
            'Si no estas de acuerdo con estos terminos, debes abstenerte de usar la plataforma y sus servicios.',
        ],
    },
    {
        title: '2. Rol de MyHoommy como intermediario tecnologico',
        paragraphs: [
            'MyHoommy es una plataforma digital de intermediacion tecnologica entre Arrendatarios, Arrendadores, Inmobiliarias y Administradores.',
            'MyHoommy no es parte del contrato de arrendamiento celebrado entre usuarios, ni sustituye asesoria legal individual en cada negocio juridico.',
        ],
        bullets: [
            'No garantiza la celebracion del contrato entre las partes.',
            'No asume obligaciones de arrendador, arrendatario o fiador, salvo pacto escrito en contrario.',
            'No representa judicial o extrajudicialmente a las partes en disputas contractuales.',
        ],
    },
    {
        title: '3. Cuentas, roles y responsabilidades de usuario',
        paragraphs: [
            'Cada usuario debe suministrar informacion veraz, completa y actualizada, y es responsable por toda actividad realizada desde su cuenta.',
        ],
        bullets: [
            'Arrendadores e inmobiliarias deben publicar informacion real sobre inmuebles, disponibilidad y condiciones.',
            'Arrendatarios deben actuar de buena fe y usar datos de contacto y documentacion autentica.',
            'Administradores deben operar conforme a las autorizaciones y limites dados por el titular o propietario.',
        ],
    },
    {
        title: '4. Verificacion de estudiantes',
        paragraphs: [
            'El flujo de verificacion estudiantil de MyHoommy exige documentos autenticos, vigentes y legalmente obtenidos.',
            'El usuario declara bajo gravedad de juramento que los documentos cargados son veraces y no han sido alterados.',
        ],
        bullets: [
            'MyHoommy puede rechazar, suspender o cancelar verificaciones por inconsistencias o indicios de fraude.',
            'La obtencion de la insignia estudiantil no constituye garantia de otorgamiento de contrato por parte del arrendador.',
            'MyHoommy puede solicitar documentos adicionales para validacion razonable.',
        ],
    },
    {
        title: '5. Proteccion de datos personales (Habeas Data)',
        paragraphs: [
            'El tratamiento de datos personales se realiza conforme a la Ley 1581 de 2012, el Decreto 1377 de 2013 y normas complementarias en Colombia.',
            'Para conocer detalles sobre finalidades, derechos del titular y procedimientos de consulta o reclamo, consulta la Politica de Privacidad de MyHoommy.',
        ],
        bullets: [
            'Puedes ejercer tus derechos de acceso, actualizacion, rectificacion, supresion y revocatoria de autorizacion cuando proceda.',
            'Las solicitudes de privacidad deben presentarse por los canales oficiales indicados en la Politica de Privacidad.',
        ],
    },
    {
        title: '6. Uso permitido y prohibiciones',
        paragraphs: [
            'El usuario se obliga a utilizar MyHoommy de forma licita, etica y conforme a la ley colombiana.',
        ],
        bullets: [
            'Esta prohibido realizar scraping, extraccion automatizada masiva o mineria no autorizada de datos.',
            'Esta prohibido suplantar identidad, manipular verificaciones o usar documentos falsos.',
            'Esta prohibido publicar contenido enganoso, discriminatorio, fraudulento o contrario a la ley.',
            'Esta prohibido intentar vulnerar la seguridad, disponibilidad o integridad de la plataforma.',
        ],
    },
    {
        title: '7. Pagos, pasarelas y comisiones',
        paragraphs: [
            'Cuando aplique, MyHoommy puede habilitar pagos y recaudos mediante terceros proveedores de servicios de pago.',
            'Las comisiones, cargos por servicio o costos transaccionales se informaran antes de confirmar la operacion correspondiente.',
        ],
        bullets: [
            'Las condiciones financieras pueden variar segun producto, rol o integracion de pago.',
            'Los tiempos de procesamiento, reversiones o rechazos pueden depender de la pasarela y de entidades financieras.',
        ],
    },
    {
        title: '8. Limitacion de responsabilidad',
        paragraphs: [
            'MyHoommy no garantiza el estado fisico, juridico o comercial de los inmuebles publicados por terceros.',
            'MyHoommy no responde por incumplimientos de pago, entrega, conservacion o cualquier obligacion derivada del contrato de arrendamiento entre usuarios.',
            'En todo caso permitido por la ley, la responsabilidad de MyHoommy se limita a danos directos debidamente probados y atribuibles de manera inmediata a su conducta.',
        ],
    },
    {
        title: '9. Suspension, terminacion y medidas de cumplimiento',
        paragraphs: [
            'MyHoommy podra suspender o cancelar cuentas, anuncios o funcionalidades ante incumplimientos de estos terminos, requerimientos legales o riesgos de seguridad.',
        ],
        bullets: [
            'Las medidas pueden incluir bloqueo temporal, despublicacion de contenido y cancelacion definitiva de la cuenta.',
            'MyHoommy podra conservar evidencia para cumplimiento normativo y colaboracion con autoridades competentes.',
        ],
    },
    {
        title: '10. Ley aplicable y resolucion de controversias',
        paragraphs: [
            'Estos terminos se rigen por las leyes de la Republica de Colombia.',
            'Toda controversia relacionada con el uso de la plataforma se intentara resolver primero de forma directa entre las partes y, en su defecto, ante la jurisdiccion competente en Colombia.',
        ],
    },
    {
        title: '11. Modificaciones y vigencia',
        paragraphs: [
            'MyHoommy puede modificar estos terminos por cambios normativos, operativos o de seguridad. Las modificaciones seran publicadas en la plataforma con su fecha de actualizacion.',
            'El uso continuado de la plataforma despues de la publicacion implica aceptacion de los cambios, salvo que la ley exija consentimiento adicional.',
        ],
    },
];

export const TERMS_HUMAN_SUMMARY = [
    'MyHoommy conecta partes y facilita procesos, pero no reemplaza el contrato entre arrendador y arrendatario.',
    'Debes usar datos reales; documentos falsos o suplantacion implican bloqueo o cancelacion de cuenta.',
    'Tus datos se tratan bajo la ley colombiana de Habeas Data y puedes ejercer tus derechos como titular.',
    'Pagos y comisiones se informan antes de cada operacion y pueden depender de terceros de pago.',
    'Cualquier conflicto se rige por la ley colombiana y se atiende ante autoridades competentes en Colombia.',
];
